import { c as _c } from "react/compiler-runtime";
export default function NowMintingCountdownLoading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-relative tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-white/5 tw-bg-iron-900/40 tw-p-3 tw-text-left md:tw-p-4"><div className="tw-flex tw-flex-col tw-gap-2"><div className="tw-h-3 tw-w-28 tw-animate-pulse tw-rounded tw-bg-iron-700/70" /><div className="tw-h-7 tw-w-44 tw-animate-pulse tw-rounded tw-bg-iron-700/70" /><div className="tw-h-10 tw-w-full tw-animate-pulse tw-rounded-lg tw-bg-iron-700/70" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}